export default __webpack_public_path__ + "static/media/sdg.c7282029.png";